<template>
  <div class="card p-0 m-0">
    <div class="card-body p-0 m-0">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center ms-2 mt-2">
          <h4 class="card-title mb-0">Orderbevestiging Details</h4>
        </div>
      </div>
      <div class="row p-0 ms-0 me-2">
        <div class="col-12 p-1 m-0 d-flex justify-content-between">
          <h3>{{ orderConfirmation.customer_name }}{{ getHeader(orderConfirmation.reference) }}{{ getHeader(getFormatedDateTime(orderConfirmation.created_at)) }}</h3>
        </div>
      </div>
      <div class="row p-0 m-0">
        <div class="col-lg-3 col-md-4 mt-2 mb-2">
          <div class="d-flex align-items-center">
            <i class="bi bi-circle-fill me-2" :class="getColor(orderConfirmation.status_id)"></i>
            <select v-model="orderConfirmation.status_id" @change="updateOrderConfirmationStatus" class="form-select">
              <option v-for="status in orderConfirmationStatussen" :key="status.id" :value="status.id">
                {{ status.label }}
              </option>
            </select>
          </div>
          <div v-if="orderConfirmation.error_message" class="mt-2 small-text">
            <b>{{ getFormatedDateTime(orderConfirmation.created_at) }}</b> - <span v-html="orderConfirmation.error_message"></span>
          </div>
        </div>
        <div class="col-lg-9 col-md-8 mb-3 py-2" >
          <OrderBevestigingDetailTab @click="select" :selectedView="selectedView"></OrderBevestigingDetailTab>
          <div class="border no-top-border p-3 custom-border-radius">
            <!-- Object View -->
            <div class="row" v-if="selectedView=='object'">
              <div class="d-flex justify-content-end mb-2">
                <button type="button" class="btn btn-sm btn-outline-secondary py-1 px-2" 
                  @click="copyObjectToClipboard()">
                  <i class="bi bi-clipboard"></i>
                </button>
              </div>
              <div class="col-12">
                <div class="property-list">
                  <div class="card mb-2">
                    <div class="card-body">
                      <h5 class="card-title">Orderbevestiging Referentie</h5>
                      <div class="row custom-row ms-0 me-0">
                        <div class="col-auto">
                          <label for="orderConfirmationReference" class="col-form-label">Referentie</label>
                          <EditOrderConfirmationProp id="orderConfirmationReference" :type="'text'" :classStr="'text-end'" :styleStr="'max-width: 12em;'" :rowIndex="index"
                            :property="orderConfirmationReference" @changed="referenceChanged" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Customer Info -->
              <div class="col-lg-6 col-md-6">
                <div class="property-list">
                  <div class="card mb-2">
                    <div class="card-body">
                      <h5 class="card-title">Klant Informatie</h5>
                      <div class="row custom-row ms-0 me-0">
                        <div class="mb-2">
                          <strong>Naam:</strong> {{ orderConfirmation.customer_name }}
                        </div>
                        <div class="mb-2">
                          <strong>Klantcode:</strong> {{ orderConfirmation.customer_code || 'Niet beschikbaar' }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Order Info -->
              <div class="col-lg-6 col-md-6">
                <div class="property-list">
                  <div class="card mb-2">
                    <div class="card-body">
                      <h5 class="card-title">Order Informatie</h5>
                      <div class="row custom-row ms-0 me-0">
                        <div class="mb-2">
                          <strong>VO-nummer:</strong> {{ orderConfirmation.vo_number || 'Niet beschikbaar' }}
                        </div>
                        <div class="mb-2">
                          <strong>Aangemaakt:</strong> {{ getFormatedDateTime(orderConfirmation.created_at) }}
                        </div>
                        <div class="mb-2">
                          <strong>Bijgewerkt:</strong> {{ getFormatedDateTime(orderConfirmation.updated_at) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- XML View -->
            <div v-if="selectedView=='xml'" class="mb-2 d-flex justify-content-end">
              <button type="button" class="btn btn-sm btn-outline-secondary py-1 px-2" 
                @click="copyXmlToClipboard()">
                <i class="bi bi-clipboard"></i>
              </button>
            </div>
            <editable-xml-view
              v-if="selectedView=='xml'"
              ref="editableXmlView"
              :editable="true"
              :initialXml="orderConfirmation.xml_data"
              @updateXml="updateXml"
              :key="'xml-view-' + orderConfirmation.id"
            ></editable-xml-view>
            
            <!-- JSON View (Nieuw) -->
            <div v-if="selectedView=='json'" class="mb-2 d-flex justify-content-end align-items-center">
              <div class="btn-group me-2" role="group" aria-label="JSON view switch">
                <button type="button" class="btn btn-sm"
                  :class="jsonViewMode === 'tree' ? 'btn-primary' : 'btn-outline-primary'"
                  @click="jsonViewMode = 'tree'">Tree</button>
                <button type="button" class="btn btn-sm"
                  :class="jsonViewMode === 'pretty' ? 'btn-primary' : 'btn-outline-primary'"
                  @click="jsonViewMode = 'pretty'">Pretty</button>
              </div>
              <button type="button" class="btn btn-primary btn-sm me-2"
                @click="retryOrderConfirmationWithJson()">
                <i class="bi bi-arrow-repeat me-1"></i>
                Opnieuw versturen (JSON)
              </button>
              <button type="button" class="btn btn-sm btn-outline-secondary py-1 px-2" 
                @click="copyJsonToClipboard()">
                <i class="bi bi-clipboard"></i>
              </button>
            </div>
            <json-tree 
              v-if="selectedView=='json' && orderConfirmation.json_data && jsonViewMode === 'tree'" 
              :data="orderConfirmation.json_data"
              :key="'json-tree-' + orderConfirmation.id"
            ></json-tree>
            <div v-if="selectedView=='json' && jsonViewMode === 'pretty'">
              <editable-json-view
                ref="editableJsonView"
                :editable="true"
                :initialJson="orderConfirmation.json_data || {}"
                @updateJson="updateOrderConfirmationJson"
                @showToast="showToast"
                :key="'json-view-' + orderConfirmation.id"
              ></editable-json-view>
            </div>
            
            <!-- Response View -->
            <div v-if="selectedView=='response'" class="response-container">
              <div class="mb-2 d-flex justify-content-end">
                <button type="button" class="btn btn-sm btn-outline-secondary py-1 px-2" 
                  @click="copyResponseToClipboard()">
                  <i class="bi bi-clipboard"></i>
                </button>
              </div>
              <div class="card mb-3">
                <div class="card-body">
                  <h5 class="card-title">Response Data</h5>
                  <div class="alert alert-info" v-if="!orderConfirmation.response">
                    Geen response data beschikbaar voor deze orderbevestiging.
                  </div>
                  <pre v-else class="response-content">{{ formatResponseContent(orderConfirmation.response) }}</pre>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ServiceFactory from "../services/ServiceFactory"
import Utils from "../utils/Utils"
import JsonTree from '../components/JsonTree.vue'
import EditableXmlView from '../components/EditableXmlView.vue'
import OrderBevestigingDetailTab from '../components/OrderBevestigingDetailTab.vue'
import EditOrderConfirmationProp from '../components/EditOrderConfirmationProp.vue'
import EditableJsonView from '../components/EditableJsonView.vue'

export default {
  name: 'OrderBevestigingDetailPage',
  props: ['id'],
  emits: ['showToast'],
  components: { JsonTree, EditableXmlView, OrderBevestigingDetailTab, EditOrderConfirmationProp, EditableJsonView },
  data() {
    return {
      orderConfirmation: {},
      orderConfirmationReference: '',
      orderConfirmationStatussen: [],
      originalStatusId: null,
      selectedView: 'object',
      jsonViewMode: 'tree',
      index: -1,
      orderConfirmationService: ServiceFactory.getService('OrderConfirmationService')
    }
  },
  computed: {
    prettyJson() {
      return this.getPrettyJson(this.orderConfirmation?.json_data || {});
    }
  },
  methods: {
    updateOrderConfirmationJson(newJson) {
      this.orderConfirmation.json_data = newJson;
    },
    async retryOrderConfirmationWithJson() {
      try {
        let dataToSend = this.orderConfirmation.json_data;
        if (this.jsonViewMode === 'pretty') {
          const editableJsonView = this.$refs.editableJsonView;
          if (editableJsonView) {
            const jsonContent = editableJsonView.jsonContent;
            dataToSend = JSON.parse(jsonContent);
          }
        }
        const response = await this.orderConfirmationService.retryOrderConfirmation(this.orderConfirmation.id, dataToSend);
        if (response.success) {
          this.$emit('showToast', ['Orderbevestiging opnieuw verstuurd met aangepaste JSON', 'bg-success']);
          this.loadOrderConfirmationDetail();
        } else {
          this.$emit('showToast', [`Fout bij opnieuw versturen: ${response.message || 'Onbekende fout'}`, 'bg-danger']);
        }
      } catch (error) {
        console.error('Fout bij opnieuw versturen orderbevestiging:', error);
        this.$emit('showToast', [error.message || 'Er is een fout opgetreden bij het opnieuw versturen', 'bg-danger']);
      }
    },
    async loadOrderConfirmationDetail() {
      try {
        const id = parseInt(this.$route.params.id);
        if (isNaN(id)) {
          console.error('Ongeldig orderbevestiging ID');
          return;
        }
        
        // Laad de orderbevestigingsstatussen
        const statuses = await this.orderConfirmationService.getAllOrderConfirmationStatuses();
        this.orderConfirmationStatussen = statuses || [];
        
        // Laad de specifieke orderbevestiging
        const orderConfirmation = await this.orderConfirmationService.getOrderConfirmationById(id);
        
        if (orderConfirmation) {
          this.orderConfirmation = orderConfirmation;
          this.orderConfirmationReference = orderConfirmation.reference || '';
          this.originalStatusId = orderConfirmation.status_id;
        } else {
          console.error('Orderbevestiging niet gevonden');
          this.$emit('showToast', ['Orderbevestiging niet gevonden', 'bg-danger']);
        }
      } catch (error) {
        console.error('Fout bij het laden van orderbevestiging details:', error);
        this.$emit('showToast', ['Er is een fout opgetreden bij het laden van de orderbevestiging', 'bg-danger']);
      }
    },
    getFormatedDateTime(isoString) {
      return Utils.formatDateTimeString(isoString);
    },
    getColor(statusId) {
      // Implementeer kleur op basis van status
      return Utils.getColorForOrderConfirmationStatus(statusId);
    },
    getHeader(txt) {
      if (txt && txt !== '') {
        return " - " + txt;
      }
      return '';
    },
    async updateOrderConfirmationStatus() {
      try {
        const result = await this.orderConfirmationService.updateOrderConfirmationStatus(
          this.orderConfirmation.id, 
          this.orderConfirmation.status_id
        );
        
        if (result.success) {
          this.$emit('showToast', ['Orderbevestiging status succesvol bijgewerkt', 'bg-success']);
          this.originalStatusId = this.orderConfirmation.status_id;
        } else {
          this.$emit('showToast', [`Fout bij het bijwerken van de status: ${result.message}`, 'bg-danger']);
          this.orderConfirmation.status_id = this.originalStatusId;
        }
      } catch (error) {
        console.error('Fout bij het updaten van de orderbevestiging status:', error);
        this.$emit('showToast', ['Er is een fout opgetreden bij het bijwerken van de status', 'bg-danger']);
        this.orderConfirmation.status_id = this.originalStatusId;
      }
    },
    referenceChanged(value) {
      this.orderConfirmationReference = value;
      this.updateReference(value);
    },
    async updateReference(reference) {
      try {
        const result = await this.orderConfirmationService.updateOrderConfirmationReference(
          this.orderConfirmation.id, 
          reference
        );
        
        if (result.success) {
          this.orderConfirmation.reference = reference;
          this.$emit('showToast', ['Referentie succesvol bijgewerkt', 'bg-success']);
        } else {
          this.$emit('showToast', [`Fout bij het bijwerken van de referentie: ${result.message}`, 'bg-danger']);
          this.orderConfirmationReference = this.orderConfirmation.reference;
        }
      } catch (error) {
        console.error('Fout bij het updaten van de referentie:', error);
        this.$emit('showToast', ['Er is een fout opgetreden bij het bijwerken van de referentie', 'bg-danger']);
        this.orderConfirmationReference = this.orderConfirmation.reference;
      }
    },
    async updateXml(newXml) { 
      try {
        const response = await this.orderConfirmationService.updateOrderConfirmationXml(
          this.orderConfirmation.id, 
          newXml
        );
        
        if (response.success) {
          this.orderConfirmation.xml_data = newXml;
          this.$emit('showToast', ['XML-wijzigingen succesvol toegepast', 'bg-success']);
          
          // Laad de details opnieuw om eventueel bijgewerkte JSON data te krijgen
          this.loadOrderConfirmationDetail();
        } else {
          this.$emit('showToast', [`Fout bij het toepassen van XML-wijzigingen: ${response.message}`, 'bg-danger']);
        }
      } catch (error) {
        console.error('Fout bij het updaten van XML:', error);
        this.$emit('showToast', ['Er is een fout opgetreden bij het bijwerken van de XML', 'bg-danger']);
      }
    },
    select(view) {
      this.selectedView = view;
    },
    formatResponseContent(responseData) {
      if (!responseData) return '';
      try {
        // Try to parse as JSON for better formatting
        const parsedData = JSON.parse(responseData);
        return JSON.stringify(parsedData, null, 2);
      } catch (e) {
        // If not valid JSON, return as is
        return responseData;
      }
    },
    getPrettyJson(data) {
      try {
        return JSON.stringify(data, null, 2);
      } catch (e) {
        return '';
      }
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text)
        .then(() => this.$emit('showToast', ['Gekopieerd naar klembord', 'bg-success']))
        .catch(err => this.$emit('showToast', [`Fout bij kopiëren: ${err.message}`, 'bg-danger']));
    },
    copyObjectToClipboard() {
      try {
        const data = this.orderConfirmation?.json_data ?? this.orderConfirmation ?? {};
        const text = typeof data === 'string' ? data : JSON.stringify(data, null, 2);
        this.copyToClipboard(text);
      } catch (e) {
        this.$emit('showToast', ['Kon object niet serializen', 'bg-danger']);
      }
    },
    copyJsonToClipboard() {
      try {
        const data = this.orderConfirmation?.json_data ?? {};
        const text = JSON.stringify(data, null, 2);
        this.copyToClipboard(text);
      } catch (e) {
        this.$emit('showToast', ['Kon JSON niet kopiëren', 'bg-danger']);
      }
    },
    copyXmlToClipboard() {
      const xmlContent = this.$refs.editableXmlView?.xmlContent || this.orderConfirmation?.xml_data || '';
      this.copyToClipboard(xmlContent);
    },
    copyResponseToClipboard() {
      const text = this.formatResponseContent(this.orderConfirmation?.response || '');
      this.copyToClipboard(text);
    }
  },
  watch: {
    // Herlaad de orderbevestiging wanneer er via de subnav-navigatie naar een ander id wordt genavigeerd
    id(newId, oldId) {
      if (newId && newId !== oldId) {
        this.loadOrderConfirmationDetail();
      }
    }
  },
  mounted() {
    this.loadOrderConfirmationDetail();
  }
}
</script>

<style scoped>
.card {
  border: none;
}
.custom-border-radius {
  border-radius: 0 0 7px 7px;
}
.no-top-border {
  border-top: none !important;
}
.property-list {
  display: flex;
  flex-direction: column;
}
.custom-row {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 1em;
  margin-bottom: 1em;
}
.response-container {
  padding: 0.5rem;
}
.response-content {
  background-color: #f8f9fa;
  border-radius: 5px;
  padding: 1rem;
  max-height: 500px;
  overflow-y: auto;
  white-space: pre-wrap;
  font-family: monospace;
  font-size: 0.9rem;
}
.json-pre pre {
  background-color: #f8f9fa;
  border-radius: 5px;
  padding: 1rem;
  max-height: 500px;
  overflow-y: auto;
  white-space: pre-wrap;
  font-family: monospace;
  font-size: 0.9rem;
}
.small-text {
  font-size: 0.875rem;
  line-height: 1.2;
}
</style>